//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Swiper from 'swiper'
  
  export default {
    name: 'index',
    props: {
      videoUrl: {
        type: Array,
        required: true,
        default: [],
        desc: '视频地址'
      },
      showState: {
        type: Boolean,
        required: true,
        default: false,
        desc: '视频播放弹层显示'
      }
    },
    data () {
      return {
        showPic: true,
        showVideo: false,
        onePlay: ''
      }
    },
    computed: {
      show () {
        return this.showState
      }
    },
    mounted(){
        new Swiper('.video-banner', {
              slidesPerView: 'auto',
              spaceBetween: 20,
              observer: true,
              observeParents: true,
              // loop: true,
              // autoplayDisableOnInteraction: false,
              // autoplay: 3500,
              // speed: 700,
            });
    },
    methods: {
      videoStop () {
        this.$refs.oneVideo.pause()
        this.$parent.videoShow = false
      },
      videoStopOne () {
        this.showPic = true
        this.showVideo = false
        this.onePlay = ''
      },
      videostart (index) {
        this.onePlay = this.videoUrl[index].src != "" ? this.videoUrl[index].src : this.PIC_BASE_URL + this.videoUrl[index].videos[0][0].fileUrl
        this.showPic = false
        this.showVideo = true
        const that = this
        if (this.onePlay != '') {
          // if(that.$refs.oneVideo.buffered()){
          //     setTimeout(function () {
          //      that.$refs.oneVideo.buffered()
          //     }, 200)
          // }else{
          setTimeout(function () {
            that.$refs.oneVideo.play()
          }, 200)
          // }
        }
      },
    }
  }
  